import { render } from "./AudienceView.vue?vue&type=template&id=9ded7a24"
import script from "./AudienceView.vue?vue&type=script&lang=js"
export * from "./AudienceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__